"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderElement = exports.ContentContainer = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
exports.ContentContainer = (0, styled_1.default)('div') `
  padding-top: ${(0, ui_theme_1.fromTheme)('spacing_large')};
  font-family: ${(0, ui_theme_1.fromTheme)('font_face')};
  font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
  line-height: ${(0, ui_theme_1.fromTheme)('font_line_height')};
  overflow-wrap: break-word;
  overflow-x: auto;
  table {
    table-layout: fixed;
    min-width: 100%;
  }
  & img {
    max-width: 100%;
  }
  & hr {
    border: none;
    height: 1px;
    background-color: ${(0, ui_theme_1.fromTheme)('color_border')};
  }
`;
exports.HeaderElement = (0, styled_1.default)('h1') ``;
//# sourceMappingURL=PracticeGuide.styles.js.map